<div class="invite-component">
  <app-invite-list [userId]="detailId()" *ngIf="detailId()"></app-invite-list>
</div>
